import React, { useEffect } from "react";
import $ from 'jquery';


export default function ServiceAccess_StudentApp(props) {
    const itemCode = props.match.params.itemCode;

    let checkItemCode = () => {
        let item = document.getElementById(itemCode);
        if (item === null) {
            setTimeout(checkItemCode, 1000);
        } else {
            item.submit();
            // setTimeout(props.history.goBa ck(), 2000);
        }
    };

    useEffect(() => {
        $(document).ready(function () {
            checkItemCode()
            fetch(`api/general/ServiceAccess/${itemCode}`)
            //fetch(`api/general/LogService/${itemCode}`)

        });

    }, [])

    return <div> </div>;
}



// WEBPACK FOOTER //
// ./src/pages/ServiceAccess/ServiceAccess_StudentApp.js